module.exports = __webpack_public_path__ + "static/media/vr_img.28bbc06c.png";